<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>

    <v-card-title style="padding: 28px;">
      <v-row>
        <v-col cols="12" md="4" sm="12" lg="4" xl="3" >
        <v-text-field prepend-inner-icon="mdi-magnify" color="primary" label="Search" style="max-width: 300px;" variant="outlined" v-model="search"
          v-on:keyup.enter="loadData('search')"></v-text-field>
        </v-col>
        <v-col cols="12"  md="8" sm="12" lg="8" xl="9">
          <v-row>
            <v-spacer></v-spacer>
            <v-card-actions style="margin-bottom: 10px;">
              <v-btn class="mr-2 mb-2" x-lage :color="disableAssign? '' : 'primary'" variant="flat" style="min-height: 56px;" :disabled="disableAssign" @click="handleDialogOpen('assign')">ASSIGN</v-btn>
              <v-btn class="mr-2 mb-2" x-large :color="disableUnAssign? '' : 'primary'" variant="flat" style="min-height: 56px;" :disabled="disableUnAssign"
                @click="handleDialogOpen('Confirm unassign')">UNASSIGN</v-btn>
              <v-btn class="mr-2 mb-2" x-large variant="flat" style="min-height: 56px;" v-if="(selected.length === 0) || disableDisposition" disabled
              :color="(selected.length === 0) || disableDisposition ? '' : 'primary'"
                >
                Change Disposition
                <v-icon color="grey">mdi-menu-down</v-icon>
              </v-btn>

              <v-menu offset-y v-if="(selected.length > 0) && !disableDisposition" v-model="menuOpen">
                <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" x-large dark v-bind="props" class="mr-2 mb-2" style="min-height: 56px;">
                    Change Disposition
                    <v-icon v-if="menuOpen" color="white">mdi-menu-up</v-icon>
                    <v-icon v-else color="white">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item class="cursor-pointer row-pointer" v-for="(item, index) in changeDispositionOptions"
                    :key="index">
                    <v-list-item-title @click="changeDisposition(item)">
                      {{ item.code }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-actions>

            <v-expansion-panels class="custom-control_outlined filter-panels-btn" ref="filterPopupRef" readonly
              style="max-width: 300px; margin-bottom: 28px; min-height: 56px;">
              <v-expansion-panel variant="outlined" @click="handleFilterPopup">
                <v-expansion-panel-title>Filter
                </v-expansion-panel-title>
              </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
        </v-col>
      </v-row>

    </v-card-title>
    <v-layout column>
      <v-col cols="12" style="overflow: auto" class='p-0'>
        <v-data-table
          density="compact"
          :search="search"
          v-model="setselectedItem"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="formattedTableData"
          :loading="loading === 'table_data'"
          fixed-header
          :items-per-page="pageSize"
          hover
          height="100%"
          loading-text="Loading Data... Please wait" class="elevation-1"
          >
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <!-- pagination display -->
    <v-container fluid>
      <v-row class="ml-2 pb-0">
        <v-col cols="3" sm="3" class="PaddingItemPerPage d-flex mt-3">
          <label class="" style="margin-top: -2px;">Rows Per Page</label>
          <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange" variant="outlined" style="width: 40px;margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
        </v-col>
        <span class="item-selected">
          <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span>
          <span v-if="selected.length > 1">{{ selected.length }} Items Selected</span>
        </span>
        <v-spacer></v-spacer>
        <span class="pt-3 mt-3 mr-5" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }} - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
        <v-col cols="2" sm="2" class="PaddingItemPerPage custom-column-ui">
          <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui" @update:modelValue="handlePageChange" circle></v-pagination>
        </v-col>
      </v-row>
    </v-container>

    <v-row justify="center">
      <v-dialog v-model="dialogDitails.open" persistent :max-width="dialogDitails.maxWidth">
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ dialogDitails.headerText }}</span><br>
            <v-spacer></v-spacer>
            <v-btn variant='solo' icon @click="handleDialogClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="border-opacity-20 m-0" />
          <v-card-text>
            <template
              v-if="(dialogDitails.type === 'Confirm unassign') || (dialogDitails.type === 'Change disposition') || (dialogDitails.type === 'Success')">
              <div class="d-flex justify-center mt-6">
                <h6 class="text-center">
                  {{ dialogDitails.messageText }}
                </h6>
              </div>
            </template>
            <template v-if="dialogDitails.type === 'assign'">
              <v-autocomplete class="mt-10" :items='assignUserList' return-object item-title="full_name" color="primary"
                label="Enter\select employee name" variant="outlined" v-model="dialogDitails.selectedUser"></v-autocomplete>
            </template>
          </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <v-btn size="small" variant="outlined" class="btn-cancel mr-2 mb-3" @click="handleDialogClose" v-if="dialogDitails.closeBtn">{{ dialogDitails.closeText }}</v-btn>
            <v-btn size="small" variant="flat" color="primary" class="mb-3" @click="handleDialogSubmit" v-if="dialogDitails.submitBtn">{{ dialogDitails.submitText }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog content-class="filter-popup" v-model="filterPopupDetails.open" persistent max-width="936px">
        <v-card>
          <v-card-actions>
            <v-text-field append-inner-icon="mdi-magnify" color="primary" item-title="value" item-value="value" label="Tag ID" variant="outlined" 
              class="ma-2" style="max-width: 300px;" v-model="filterPopupDetails.tag_id"></v-text-field>
            <v-text-field append-inner-icon="mdi-magnify" color="primary" v-model="filterPopupDetails.article_id" label="Article ID" variant="outlined"
              class="ma-2" style="max-width: 300px;"></v-text-field>
            <v-select clearable color="primary"
              :items="[{ level: 'Assigned', value: 'assigned' }, { level: 'Unassigned', value: 'unassigned' }]"
              item-title="level" item-value="value" :loading="loading === 'UserList'" label="Status"
              v-model="filterPopupDetails.assignment_status" variant="outlined" class="ma-2" style="max-width: 300px;"></v-select>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size='small' variant='text' class="btn-cancel mr-2 mb-3" @click="handleFilterPopup('close')">CANCEL</v-btn>
            <v-btn size='small' variant='flat' color="primary" class="mb-3" @click="handleApplyFilter">APPLY
              FILTER(S)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>

<script>
  import HeaderComponent from "@/components/commoncomponents/HeaderComponent";

  export default {
    data() {
      return {
        headerText: "Capital assets",
        search: "",
        selected: [],
        alert: false,
        alert_type: "success",
        alert_message: "success",
        headers: [
          { title: "Tag ID", key: "tag_id", width: '12%', align: "start", sortable: false },
          { title: "Article Id", key: "article_id" },
          { title: "Article Description", key: "article_description" },
          { title: "Status", key: "assignment_status" },
          { title: "Assigned To", key: "assigned_to", align: "center" },
          { title: "Location", key: "distribution_center", align: "center" }
        ],
        table_data: [],
        loading: [],
        active_tab: "",
        page: 1,
        totalPages: 1,
        totalCount: '',
        pageSize: 100,
        pageSizes: [100, 200, 300],
        changeDispositionOptions: [],
        menuOpen: false,
        dialogType: "",
        dialogDitails: {
          open: false,
          maxWidth: "375px",
          closeBtn: true,
          submitBtn: true,
          submitText: "SUBMIT",
          closeText: "CANCEL",
          type: "",
          okBtn: false,
          headerText: ""
        },
        filterPopupDetails: {
          open: false
        },
        assignUserList: [],
        selectedids: []
      }
    },
    components: {
      HeaderComponent
    },

    computed: {
      setselectedItem: {
        get() {
          return this.selectedids
        },
        set(value) {
          this.selectedids = value
          this.selected = this.table_data.filter(item => value.includes(item.id) )
        }
      },
      disableAssign() {
        let location = this.getunique(this.selected, "distribution_center")
        // let assigned_to = this.selected.filter(item => item.assigned_to !== "-")
        let getstatus = this.getunique(this.selected, "assignment_status")
        let statusType = this.selected.filter(item => item.assignment_status === "assigned")
        return location.length > 1 || this.selected.length === 0 || getstatus.length > 1 || statusType.length > 0
      },

      disableUnAssign() {
        let location = this.getunique(this.selected, "distribution_center")
        let getstatus = this.getunique(this.selected, "assignment_status")
        let statusType = this.selected.filter(item => item.assignment_status === "assigned")
        return location.length > 1 || this.selected.length === 0 || statusType.length === 0 || getstatus.length > 1
      },

      disableDisposition() {
        let statusType = this.selected.filter(item => item.assignment_status === "assigned")
        return statusType.length > 0
      },

      formattedTableData() {
        return this.table_data.map((item) => {
          return {
            ...item,
            tag_id: item.tag_id || "-",
            article_id: item.article_id || "-",
            article_description: item.article_description ? item.article_description.length > 150 ? item.article_description.slice(0, 150) + "..." : item.article_description : "-",
            assignment_status: item.assignment_status || "-",
            assigned_to: item.assigned_to || "-",
            distribution_center: item.distribution_center || "-",
          }
        });
      },
    },
    created() {
      this.loadData();
      this.getDispositionList();
    },
    methods: {
      apiCaller(apiDetails) {
        return this.$httpSecured({
          method: apiDetails.method,
          url: apiDetails.url,
          params: apiDetails.params,
          data: apiDetails.body
        }).then(response => {
          if (response.data) {
            this.loading = false;
            return response.data
          }
          else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
            return { error: "No Data Found" }
          }
        }).catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          return { error: "Something went wrong from Network" }
        });

      },

      async loadData(type) {
        this.page = 1
        this.totalPages = 1
        this.pageSize = 100
        // /api/v2/warehouse/capital_assets
        this.setselectedItem = []
        let data = type === "search" ?
          {
            search_text: this.search,
            page: this.page,
            pageSize: this.pageSize
          } :
          type === "filter" ?
            {
              filter: {
                tag_id: this.filterPopupDetails.tag_id,
                article_id: this.filterPopupDetails.article_id,
                assignment_status: this.filterPopupDetails.assignment_status
              },
              page: this.page,
              pageSize: this.pageSize
            }
            : {
              page: this.page,
              per_page: this.pageSize,
            }
        this.loading = "table_data"
        let table_data = await this.apiCaller({
          method: "post",
          url: "/api/v2/warehouse/capital_assets",
          body: data
        })

        if (table_data.capital_assets) {
          this.table_data = table_data.capital_assets
          this.totalPages = table_data.meta.total_pages
          this.totalCount = table_data.meta.total_count
        }
        this.filterPopupDetails = {
          open: false
        };
        this.search = ""

      },

      async getDispositionList() {
        let list = await this.apiCaller({
          method: "get",
          url: '/api/v2/warehouse/capital_assets/get_dispositions'
        })
        if (list.dispositions) {
          this.changeDispositionOptions = list.dispositions
        }
        console.log(list, ":::::: list");
      },

      async getAssignUserList() {
        let UserList = await this.apiCaller({
          method: "get",
          url: "/api/v2/warehouse/capital_assets/get_distribution_users",
          params: { ids: this.selectedIds() }
        })
        if (UserList) {
          this.assignUserList = UserList
          this.loading = ""
        }
        console.log("UserList ::::", UserList);
      },

      getunique(arr, key) {
        return arr.filter((a, i) => arr.findIndex((s) => a[key] === s[key]) === i)
      },

      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },

      showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },

      handlePageChange(value) {
        this.page = value;
        this.loadData("pageChange")
      },

      handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1;
        this.loadData("pageSizeChange")
      },

      handleDialogOpen(type) {
        if (type === "assign") {
          this.loading = "UserList"
          this.getAssignUserList()
          this.dialogDitails = {
            ...this.dialogDitails,
            type: type,
            open: true,
            headerText: "Assign Items",
            closeBtn: false,
            maxWidth: "500px",
            submitText: "Confirm"
          }

        }
        else if (type === "Confirm unassign") {
          this.dialogDitails = {
            ...this.dialogDitails,
            type: type,
            open: true,
            headerText: "",
            maxWidth: "500px",
            submitText: "Confirm",
            messageText: `Are you sure you want to unassign ${this.selected.length} selected items?`
          }
        }
      },

      handleDialogClose() {
        this.dialogDitails = {
          open: false,
          maxWidth: "375px",
          closeBtn: true,
          submitBtn: true,
          submitText: "SUBMIT",
          closeText: "CANCEL",
          type: "",
          okBtn: false,
          headerText: ""
        }
        this.selected = []
      },

      async changeDisposition(value) {
        let changeDisposition = await this.apiCaller({
          method: "post",
          url: "/api/v2/warehouse/capital_assets/set_dispositions",
          body: {
            ids: this.selectedIds(),
            disposition: value.code
          }
        })
        if (changeDisposition.error) {
          this.handleDialogClose()
        } else {
          this.dialogDitails = {
            ...this.dialogDitails,
            type: "Success",
            open: true,
            headerText: "",
            closeBtn: false,
            maxWidth: "500px",
            submitText: "OK",
            messageText: changeDisposition.message || `${this.selected.length} item moved to ${value.title} disposition`
          }
        }
      },

      async handleDialogSubmit() {
        let dialogType = this.dialogDitails.type
        if (dialogType === 'assign') {
          let assign_user = await this.apiCaller({
            method: "post",
            url: "/api/v2/warehouse/capital_assets/assigned_user",
            body: {
              ids: this.selectedIds(),
              full_name: this.dialogDitails.selectedUser.full_name,
              username: this.dialogDitails.selectedUser.username
            }
          })
          if (assign_user.error) {
            this.handleDialogClose()
          } else {
            this.dialogDitails = {
              ...this.dialogDitails,
              type: 'Success',
              open: true,
              headerText: "",
              closeBtn: false,
              maxWidth: "500px",
              submitText: "OK",
              messageText: `${this.selected.length} ${this.selected.length > 1 ? "items" : "item"} successfully assigned to ${this.dialogDitails.selectedUser.full_name}`
            }

          }
        } else if (dialogType === 'Confirm unassign') {
          let unassign_user = await this.apiCaller({
            method: "post",
            url: "/api/v2/warehouse/capital_assets/unassigned_user",
            body: { ids: this.selectedIds() }
          })
          // 
          if (unassign_user.error) {
            this.handleDialogClose()
          } else {
            this.dialogDitails = {
              ...this.dialogDitails,
              type: 'Success',
              open: true,
              headerText: "",
              closeBtn: false,
              maxWidth: "500px",
              submitText: "OK",
              messageText: `${this.selected.length} items successfully unassigned`
            }
          }
        }
        else if (dialogType === 'Change disposition') {
          this.handleDialogClose()
        }
        else if (dialogType === 'Success') {
          this.handleDialogClose()
          this.loadData()
        }
      },

      handleFilterPopup(type) {
        if (type === "close") {
          this.filterPopupDetails = {
            open: false
          };
        } else {
          document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 20).toString() + 'px');
          this.filterPopupDetails = {
            open: true
          };
        }
      },

      selectedIds() {
        return this.selected.map(item => item.id)
      },
      handleApplyFilter() {
        this.loadData("filter")
      }
    }
  }
</script>
<style>
  .custom-control_outlined .v-expansion-panel:before { box-shadow: none; }
  .custom-control_outlined button { min-height: 56px; border-width: 1px; border-color: rgba(0, 0, 0, .42); border-style: solid; }
  .custom-control_outlined button:focus { outline: none; }
  .v-dialog:has(.filter-popup) { justify-content: right; align-items: baseline; top: var(--dialog-ypos); }
  .item-selected { margin-top: 23px; position: absolute; left: 41%; }

  @media (max-height: 1104px) {
    .PaddingItemPerPage {
      padding: 8px !important;
    }
  }

  @media (min-height: 1126px) {
    .PaddingItemPerPage {
      padding: 24px !important;
    }
  }
</style>
